<template>
  <div class="goal-progression" redesign>
    <!-- Header -->
    <NomineeProgressBar
      stepName="Goal Progression"
      :programMonth="user.currentProgramMonth"
    />

    <div class="form-container goal-progression-form">
      <LoadSpinner v-if="loading" :color="`#${organizationDetails.darkBrandColor}`" />
      <template v-if="!loading">
        <SurveyResponseComponent
          :surveyResponse="surveyResponse"
          :cleanSurvey="false"
          :buttonText="$gettext('Next')"
          @survey-done="handleSubmit"
          :useSubmitButton="true"
          :darkText="true"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'
import NomineeProgressBar from '@/components/stepper/NomineeProgressBar'
import SurveyResponseComponent from '@/components/SurveyResponse'

import NomineesApi from '@/services/nominees'
import SurveyResponseModel from '@/services/surveyresponses'
import StipendRequest from '@/services/stipendRequests'

export default {
  name: 'StipendGoalProgression',
  components: {
    LoadSpinner,
    NomineeProgressBar,
    SurveyResponseComponent,
  },
  data() {
    return {
      loading: true,
      surveyResponse: null,
    }
  },
  async mounted() {
    let goalProgressionSurveyResponse = this.currentRequest.goalProgression
    this.getSurveyResponse(goalProgressionSurveyResponse)

    // Start editing ping
    this.$store.dispatch('startEditingStipendRequestPing', this.currentRequest)

    this.loading = false
  },
  unmounted() {
    this.$store.dispatch('stopEditingStipendRequestPing')
  },
  beforeRouteLeave(to, from,  next) {
    this.$store.dispatch('stopEditingStipendRequestPing')
    next()
  },
  methods: {
    getSurveyResponse(id) {
      const surveyResponsePromise = SurveyResponseModel.api
        .retrieve(id)
        .then(surveyResponse => {
          this.surveyResponse = surveyResponse
        })
        .catch(error => {
          try {
            error.response.status === 404 ? (this.errorCode = 404) : (this.errorCode = 500)
          } catch {
            this.errorCode = 500
          }
        })
      return surveyResponsePromise
    },
    handleSubmit() {
      StipendRequest.api.trackUpdate(this.currentRequest, StipendRequest.options.GOAL_PROGRESSION_UPDATED)
      return true
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars', 'currentRequest']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.goal-progression {
  display: flex;
  flex-direction: column;

  .goal-progression-form {
    @extend .constrain-tablet-and-up;

    @media (min-width: 1140px) {
      max-width: 1076px !important;
    }
  }
}
</style>
